import * as types from './_actionTypes';

const initialState = {
  smeRequests: [],
  contentRequests: [],
  loading: false,
  actionLoading: {},
  error: null
};

const adminSmeApprovalReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_SME_REQUESTS_REQUEST:
    case types.FETCH_CONTENT_REQUESTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    
    case types.FETCH_SME_REQUESTS_SUCCESS:
      return {
        ...state,
        loading: false,
        smeRequests: action.payload,
        error: null
      };
    
    case types.FETCH_CONTENT_REQUESTS_SUCCESS:
      return {
        ...state,
        loading: false,
        contentRequests: action.payload,
        error: null
      };
    
    case types.FETCH_SME_REQUESTS_FAILURE:
    case types.FETCH_CONTENT_REQUESTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    
    case types.APPROVE_SME_REQUEST:
    case types.REJECT_SME_REQUEST:
    case types.APPROVE_CONTENT_REQUEST:
      return {
        ...state,
        actionLoading: {
          ...state.actionLoading,
          [action.payload]: true
        }
      };
    
    case types.APPROVE_SME_SUCCESS:
      return {
        ...state,
        smeRequests: state.smeRequests.map(sme =>
          sme.id === action.payload
            ? { ...sme, status: 'approved' }
            : sme
        ),
        actionLoading: {
          ...state.actionLoading,
          [action.payload]: false
        }
      };
    
    case types.REJECT_SME_SUCCESS:
      return {
        ...state,
        smeRequests: state.smeRequests.map(sme =>
          sme.id === action.payload
            ? { ...sme, status: 'rejected' }
            : sme
        ),
        actionLoading: {
          ...state.actionLoading,
          [action.payload]: false
        }
      };
    
    case types.APPROVE_CONTENT_SUCCESS:
      return {
        ...state,
        contentRequests: state.contentRequests.map(content =>
          content.id === action.payload
            ? { ...content, status: 'approved' }
            : content
        ),
        actionLoading: {
          ...state.actionLoading,
          [action.payload]: false
        }
      };
    
    case types.APPROVE_SME_FAILURE:
    case types.REJECT_SME_FAILURE:
    case types.APPROVE_CONTENT_FAILURE:
      return {
        ...state,
        error: action.payload,
        actionLoading: {
          ...state.actionLoading,
          [action.meta?.id]: false
        }
      };
    
    default:
      return state;
  }
};

export default adminSmeApprovalReducer;